import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { storage } from '@/assets/storage'

import time from '@/store/time'
import runtime from '@/store/runtime'
import persistent from '@/store/persistent'
import favorites from '@/store/favorites'
import news from '@/store/news'
import auth from '@/store/auth'

Vue.use(Vuex, {})

export default () => {
  return new Vuex.Store({
    plugins: [
      createPersistedState({
        key: 'state',
        paths: ['persistent', 'favorites', 'news', 'auth'],
        storage
      })
    ],
    modules: {
      time,
      runtime,
      persistent,
      favorites,
      news,
      auth
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js